/*
  eslint-disable
    max-classes-per-file,
    prefer-spread,
    prefer-rest-params,
    class-methods-use-this,
    prefer-object-spread
*/

import { path, curry } from 'ramda';
import { Or } from '@aspectus/permissions';
import { accessMeta } from '@aspectus/vue-router-permissions';
import { checkAuth } from '@access/user';

// TODO: fix this import
// import {
//   SELLER_DASHBOARD_VIEW_NAME,
// } from '@app/Seller/routes'
// console.log(SELLER_DASHBOARD_VIEW_NAME);

import {
  QUICK_START_BASE_NAME,
} from '@app/Seller/QuickStart/routes'

import {
  PRODUCTS_LIST_NAME,
} from '@app/Seller/Products/routes'

import {
  // SHOP_STATUS_CHOICES,
  SHOP_STATUS_NEW,
  SHOP_STATUS_REQUIRES_VERIFICATION,
  SHOP_STATUS_WAITING_SIGNING_CONTRACT,
  SHOP_STATUS_VERIRIED,
  SHOP_STATUS_ACTIVE,
  SHOP_STATUS_BLOCKED,
  SHOP_STATUS_PROBLEM,
  SHOP_STATUS_SUSPENDED,
  SHOP_STATUS_DISABLED,
} from './accessTokens'

const userStateGetter = path(['state', 'shop']);

export function checkUser(checker, config = {}, ...args) {
  return checkAuth(
    checker, Object.assign({ getter: userStateGetter }, config), ...args
  );
}

export const isSuperuser = user => user.info.isSuperuser;
export const isType = curry((type, user) => user.info.props.status.props.group.value === type);
export const isPermitted = curry(
  (permission, user) => !!(window.SHOP_STATUS_CHOICES[user.info.props.status.props.group.value] &&
    window.SHOP_STATUS_CHOICES[user.info.props.status.props.group.value][permission])
);

export const toBe = type => checkUser(isType(type));
export const toBeAuthenticated = checkUser(user => user.isAuthenticated());
// export const toBeSuperuser = checkUser(isSuperuser);
export const toBeNew = toBe(SHOP_STATUS_NEW);
export const toBeRequiresVerification = toBe(SHOP_STATUS_REQUIRES_VERIFICATION);
export const toBeWaitSigningContract = toBe(SHOP_STATUS_WAITING_SIGNING_CONTRACT);
export const toBeVerified = toBe(SHOP_STATUS_VERIRIED);
export const toBeActive = toBe(SHOP_STATUS_ACTIVE);

export const toHasOwnPermission = permission => checkUser(isPermitted(permission));
export const toHasPermission = permission => new Or(
  // toBeNew,
  toHasOwnPermission(permission)
);

export const REDIRECT_MAP = {
  [SHOP_STATUS_NEW]: QUICK_START_BASE_NAME,
  [SHOP_STATUS_REQUIRES_VERIFICATION]: QUICK_START_BASE_NAME,
  [SHOP_STATUS_WAITING_SIGNING_CONTRACT]: QUICK_START_BASE_NAME,
  [SHOP_STATUS_VERIRIED]: PRODUCTS_LIST_NAME,
  // TODO: use SELLER_DASHBOARD_VIEW_NAME
  [SHOP_STATUS_ACTIVE]: 'seller:dashboard',
  [SHOP_STATUS_BLOCKED]: 'seller:blocked',
  [SHOP_STATUS_PROBLEM]: 'seller:blocked',
  [SHOP_STATUS_SUSPENDED]: 'seller:suspended',
  [SHOP_STATUS_DISABLED]: 'seller:blocked',
}
// console.log(REDIRECT_MAP[window.shop_status], '##############');
export const accessPermission = (permission, options) => accessMeta(
  toHasPermission(permission), { name: REDIRECT_MAP[window.shop_status] }, options
)
